import React, {Component} from 'react';
import RegistrationForm from "./RegistrationForm";
import OverViewTable from "./OverviewTable";
import {Label} from "@mui/icons-material";
import RegistrationApply from "./RegistrationApply";

export default class App extends React.Component {

    constructor(props) {
        super(props);

    }

    renderForm() {
        let currentAddress = window.location.href;
        if (currentAddress.indexOf("rezervace") > -1) {
            return <RegistrationForm/>
        } else if (currentAddress.indexOf("prehled-rezervaci") > -1) {
            return <OverViewTable/>
        }
        else if (currentAddress.indexOf("zadost-registrace") > -1) {
            return <RegistrationApply/>
        }
        else if(currentAddress.indexOf("registrace") > -1) {
            return <RegistrationApply/>
        }
        else{
            return <h1>Zvolil jste špatnou stranu</h1>
        }
    }

    render() {
        return (

            <div className="App">
                {this.renderForm()}
            </div>
        );
    }
}


